module.exports = __webpack_public_path__ + "static/media/6.question.ae2ab02e.mp4";